import { render, staticRenderFns } from "./PaginationDropdown.vue?vue&type=template&id=121ee46e&"
import script from "./PaginationDropdown.vue?vue&type=script&lang=js&"
export * from "./PaginationDropdown.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports